import { IConverterToStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import BaseAnimKeyframeHandler from './base-anim-keyframe-handler';
import { ICTTLAnimateBehavior } from '@tencent/slide-sdk-model';

// TODO 待扩展
export default class AnimHandler<M extends IElementBaseModel>
    extends BaseAnimKeyframeHandler<ICTTLAnimateBehavior, M> {
    public parse(
        behavior: ICTTLAnimateBehavior,
        duration: number,
        elementModel: M,
    ): IConverterToStyle | undefined {
        super.parse(behavior, duration, elementModel);
        const tempToStyle = this.getKeyframeData(duration);
        return tempToStyle;
    }
}
